export const WHATSAPP_BASE = "https://wa.me/554891904829";
export const PHONE_DISPLAY = "+55 48 9190-4829";
export const PHONE_TEL = "tel:+554891904829";

const msg = (text) => `${WHATSAPP_BASE}?text=${encodeURIComponent(text)}`;

export const LINKS = {
  cotacao: msg("Olá, João Garcez! Tenho interesse em fazer uma cotação de viagem."),
  cotacaoSite: msg("Olá, João Garcez! Vi seu site e gostaria de fazer uma cotação de viagem."),
  roteiro: msg("Olá, João Garcez! Gostaria de montar um roteiro personalizado e receber uma cotação."),
  visto: msg("Olá, João Garcez! Tenho interesse na assessoria para solicitação do visto americano."),
  grupo: msg("Olá, João Garcez! Tenho interesse em organizar uma viagem em grupo e gostaria de solicitar uma cotação."),
  corporativa: msg("Olá, João Garcez! Gostaria de solicitar uma cotação para uma viagem corporativa."),
  pagamento: msg("Olá, João Garcez! Gostaria de fazer uma cotação de viagem e conhecer as condições de pagamento."),
  proximaViagem: msg("Olá, João Garcez! Gostaria de solicitar uma cotação para minha próxima viagem."),
  flutuante: msg("Olá, João Garcez! Gostaria de fazer uma cotação."),
  destino: (nome) => msg(`Olá, João Garcez! Gostaria de conhecer roteiros para ${nome}.`),
};

export const NAV_ITEMS = [
  { label: "Destinos", href: "#destinos", testid: "nav-link-destinos" },
  { label: "Sobre", href: "#sobre", testid: "nav-link-sobre" },
  { label: "Roteiro", href: "#roteiro", testid: "nav-link-roteiro" },
  { label: "Serviços", href: "#servicos", testid: "nav-link-servicos" },
  { label: "Pagamento", href: "#pagamento", testid: "nav-link-pagamento" },
];

export const scrollToSection = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -64, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const DESTINATIONS = [
  {
    number: "01",
    name: "Chile",
    description: "Neve, montanhas, vinhos e experiências únicas.",
    image: "https://images.unsplash.com/photo-1614586125858-e695dd97d1b6?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "lg:col-span-4",
    testid: "destination-card-01",
  },
  {
    number: "02",
    name: "Nordeste & Brasil",
    description: "Praias, natureza e destinos incríveis para conhecer o Brasil.",
    image: "https://images.unsplash.com/photo-1768486173251-95f16f855830?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "lg:col-span-2",
    testid: "destination-card-02",
  },
  {
    number: "03",
    name: "Caribe",
    description: "Praias paradisíacas, resorts e dias para aproveitar sem pressa.",
    image: "https://images.unsplash.com/photo-1661410205208-f401a7d1edc8?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "lg:col-span-2",
    testid: "destination-card-03",
  },
  {
    number: "04",
    name: "África",
    description: "Safáris, natureza, cultura e experiências que ficam para a vida.",
    image: "https://images.unsplash.com/photo-1667209996109-c5c6aef7af8e?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "lg:col-span-2",
    testid: "destination-card-04",
  },
  {
    number: "05",
    name: "Europa",
    description: "História, cultura, gastronomia e diferentes destinos em uma só viagem.",
    image: "https://images.unsplash.com/photo-1609971757431-439cf7b4141b?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "lg:col-span-2",
    testid: "destination-card-05",
  },
  {
    number: "06",
    name: "Cruzeiros",
    description: "Conheça diferentes destinos enquanto aproveita a experiência a bordo.",
    image: "https://images.unsplash.com/photo-1554254648-2d58a1bc3fd5?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "lg:col-span-3",
    testid: "destination-card-06",
  },
  {
    number: "07",
    name: "Estados Unidos",
    description: "Grandes cidades, parques, praias, compras e experiências para todos os estilos.",
    image: "https://images.unsplash.com/photo-1518235506717-e1ed3306a89b?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "lg:col-span-3",
    testid: "destination-card-07",
  },
];

export const SERVICES = [
  {
    number: "01",
    category: "VISTO AMERICANO",
    title: "Assessoria para visto dos Estados Unidos",
    description:
      "Vai viajar para os Estados Unidos? Ofereço assessoria durante o processo de solicitação do visto americano, auxiliando na organização das informações, preenchimento da solicitação e orientação para as próximas etapas.",
    disclaimer:
      "Importante: a decisão sobre a concessão ou negativa do visto é exclusiva das autoridades consulares. A assessoria não garante a aprovação.",
    cta: "Conhecer a assessoria",
    href: LINKS.visto,
    testid: "service-card-visto",
  },
  {
    number: "02",
    category: "VIAGENS EM GRUPO",
    title: "Viajar em grupo fica melhor quando tudo é planejado.",
    description:
      "Está organizando uma viagem com família, amigos ou um grupo? Montamos propostas considerando quantidade de passageiros, destino, período, perfil da viagem e investimento disponível.",
    cta: "Cotar viagem em grupo",
    href: LINKS.grupo,
    testid: "service-card-grupo",
  },
  {
    number: "03",
    category: "VIAGENS CORPORATIVAS",
    title: "Soluções para sua viagem corporativa.",
    description:
      "Sua empresa precisa organizar uma viagem para colaboradores, clientes ou eventos? Conte com atendimento personalizado para passagens aéreas, hospedagem, traslados e demais serviços necessários.",
    cta: "Cotação corporativa",
    href: LINKS.corporativa,
    testid: "service-card-corporativa",
  },
];

export const PAYMENTS = [
  {
    badge: "01",
    icon: "banknote",
    title: "À vista",
    description: "Pagamento à vista, conforme as condições apresentadas na sua cotação.",
    testid: "payment-card-vista",
  },
  {
    badge: "12×",
    icon: "card",
    title: "Cartão de crédito",
    description: "Parcele sua viagem em até 12x no cartão de crédito, conforme as condições da cotação.",
    testid: "payment-card-credito",
  },
  {
    badge: "03",
    icon: "boleto",
    title: "Boleto bancário",
    description: "Opção de pagamento por boleto bancário, com condições definidas de acordo com o pacote e a viagem escolhida.",
    testid: "payment-card-boleto",
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1541417904950-b855846fe074?crop=entropy&cs=srgb&fm=jpg&q=85",
  about: "/images/joao-garcez.png",
  roteiro: "https://images.unsplash.com/photo-1619118986411-29b465253365?crop=entropy&cs=srgb&fm=jpg&q=85",
};
